<!--测试页面-->
<template>
  <div class="pageBox">
    <div class="titleBox">
      请求结果
    </div>
    <div class="contentBox">
      <p class="text">设备请求结果：{{ result }}</p>
      <p class="text">是否https被http拦截：{{ isHttpsToHttpBlocked }}</p>
    </div>
  </div>

</template>
<script>
import {singleHomeServer} from "@/common/api-config";

export default {
  data() {
    return {
      result: '',
      isHttpsToHttpBlocked: null
    };
  },
  created() {
    singleHomeServer.device().then(res => {
      if (res["code"] == 0) {
        this.result = JSON.stringify(res.data)
      } else {
        this.result = JSON.stringify(res.data)
      }
    }).catch(err => {
      this.result = JSON.stringify(err.message || err)
      // 判断是否因为https转http请求被拦截
      this.isHttpsToHttpBlocked = window.location.protocol === 'https:' && err.config.url.startsWith('http:');
    })
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.pageBox {
  width: 100%;
  height: 100%;

  .titleBox {
    width: 100%;
    height: 88px;
    background: #2E84FC;
    line-height: 88px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    font-weight: bold;
  }

  .contentBox {
    background: #F5F6FA;
    padding: 30px;
  }
}
</style>
